import { useScrollToTop } from 'features/Layouts/Layouts';
import { ReactComponent as IconArrowUp } from '../../assets/img/navSvg/iconArrowUp.svg';
import styles from './ScrollButton.module.scss';
import { useEffect, useState } from 'react';

interface Props {
  isMobile?: boolean;
}

export default function ScrollButton({ isMobile }: Props) {
  const [showScrollTop, setShowScrollTop] = useState(false);
  const layoutScrollToTop = useScrollToTop();
  const scrollToTop = () => {
    if (layoutScrollToTop?.scrollToTop) {
      layoutScrollToTop.scrollToTop();
    } else {
      const opts = { top: 0, behavior: 'smooth' } as const;
      document
        .querySelector<HTMLElement>('[data-scroll-container="content"]')
        ?.scrollTo(opts);
      document
        .querySelector<HTMLElement>('[data-scroll-container="main"]')
        ?.scrollTo(opts);
      window.scrollTo(opts);
    }
  };

  useEffect(() => {
    const SCROLL_THRESHOLD = 300;
    const updateVisibility = () => {
      const contentEl = document.querySelector<HTMLElement>(
        '[data-scroll-container="content"]',
      );
      const mainEl = document.querySelector<HTMLElement>(
        '[data-scroll-container="main"]',
      );
      const contentScroll = contentEl?.scrollTop ?? 0;
      const mainScroll = mainEl?.scrollTop ?? 0;
      const windowScroll = window.scrollY ?? 0;
      setShowScrollTop(
        contentScroll > SCROLL_THRESHOLD ||
          mainScroll > SCROLL_THRESHOLD ||
          windowScroll > SCROLL_THRESHOLD,
      );
    };
    const contentEl = document.querySelector<HTMLElement>(
      '[data-scroll-container="content"]',
    );
    const mainEl = document.querySelector<HTMLElement>('[data-scroll-container="main"]');
    contentEl?.addEventListener('scroll', updateVisibility, { passive: true });
    mainEl?.addEventListener('scroll', updateVisibility, { passive: true });
    window.addEventListener('scroll', updateVisibility, { passive: true });
    updateVisibility();
    return () => {
      contentEl?.removeEventListener('scroll', updateVisibility);
      mainEl?.removeEventListener('scroll', updateVisibility);
      window.removeEventListener('scroll', updateVisibility);
    };
  }, []);
  return showScrollTop ? (
    <div
      className={styles.buttonScroll}
      role='button'
      style={{
        opacity: showScrollTop ? 1 : 0,
        pointerEvents: showScrollTop ? 'auto' : 'none',
        transition: 'opacity 0.2s ease',
        width: isMobile ? '48px' : undefined,
        height: isMobile ? '48px' : undefined,
      }}
      tabIndex={0}
      onClick={scrollToTop}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          scrollToTop();
        }
      }}
      aria-label='Наверх'>
      <IconArrowUp
        style={{
          width: isMobile ? '24px' : '16px',
          height: isMobile ? '24px' : '16px',
        }}
      />
    </div>
  ) : null;
}
